import { ROLE_VALUES } from "@noa/api-core";
import { type FunctionComponent } from "react";
import { useMessages } from "@noa/client-store";
import { useActionDescription } from "@noa/client-store";

export const ChatActionDescription: FunctionComponent = () => {
  const actionDescription = useActionDescription();
  const messages = useMessages();

  // Don't show here if there's a streaming ASSISTANT message (it will show inside ChatMessage)
  const lastMessage = messages[messages.length - 1];
  const hasStreamingAssistantMessage =
    lastMessage && lastMessage.role === ROLE_VALUES.ASSISTANT && lastMessage.message_id === "";

  if (!actionDescription || hasStreamingAssistantMessage) return null;

  return <div className="ml-15 mr-24 py-2 italic text-[0.9em] text-noa-muted">{actionDescription}</div>;
};
